// extracted by mini-css-extract-plugin
module.exports = {"boxWrap":"PickerColorBox_boxWrap__2T8eD","box":"PickerColorBox_box__2Z9hh","text":"PickerColorBox_text__37fvH"};